module.exports = __webpack_public_path__ + "img/emoji_33.dc35dc50.png";